import { BasicTable } from '@components';
import SectionCard from '@mobileComponents/SectionCard';
import { customerDetailsStore } from '@mobileStore/customer';
import { CustomerOutstandingOrders } from '@typeDefinitions/customerTypes';
import { formatAmount } from '@utils/utils';
import { DateTime } from 'luxon';

const OutstandingInvoices = () => {
  const columns = [
    {
      name: 'Order #',
      key: 'orderId',
    },
    {
      name: 'Invoice Date',
      key: 'invoicedDate',
      renderCell: (row: CustomerOutstandingOrders) =>
        row.invoicedDate
          ? DateTime.fromISO(row.invoicedDate).toFormat('MM/dd/yyyy')
          : '',
    },
    {
      name: 'Days Elapsed',
      key: 'daysElapsed',
    },
    {
      name: 'Amount',
      key: 'amount',
      renderCell: (row: CustomerOutstandingOrders) => formatAmount(row.amount),
    },
  ];

  return (
    <SectionCard
      title={
        <>
          Outstanding Invoices
          {(customerDetailsStore.customer.outstandingOrders?.length ?? 0) >
            0 && (
            <span class="bg-white text-black rounded-full px-2 py-0.5 text-sm ml-2">
              {customerDetailsStore.customer.outstandingOrders?.length}
            </span>
          )}
        </>
      }
    >
      <div
        class="[&>table>.MuiTableHead-root]:bg-[#f2f2f2]"
        style={{
          padding: '8px',
          height: 'auto',
          'max-height': '350px',
          'overflow-y': 'auto',
        }}
      >
        <BasicTable
          columns={columns}
          rows={customerDetailsStore.customer.outstandingOrders || []}
          cellClasses="text-[14px]!"
          tableBodyClasses="text-[14px]!"
          imgClass="w-12! h-12!"
        />
      </div>
    </SectionCard>
  );
};

export default OutstandingInvoices;
